export default __webpack_public_path__ + "static/media/thumbnail.9539cbf4.png";